import { appDataReducerPaginationAndSearch } from './reducerMetadata';

export function AppDataReducerSessionsSourceOverview(state, action) {
    const data = action?.sessionsSourceOverview?.message?.data || {};

    return {
        meta: appDataReducerPaginationAndSearch(action?.sessionsSourceOverview?.message?.meta),
        ...data,
    };
}
